import { useEffect, useState } from 'react';
import './LeadReminders.css';
import { capitalizeFirstLetter } from '../../utilities/services/capitalizeFirstLetter';
import { createLeadReminder, getAllLeadReminders } from '../../utilities/api/leads';
import { formNotificationStyle2 } from '../../utilities/services/formNotification';
import { leadReminderFields } from '../../utilities/services/reminderFields';


const defaultFormData = {
    status: '',
    fieldOfInterest: '',
    message: '',
    numberOfDays: '0',
    beforeOrAfter: '',
};

export default function LeadReminders({user, toggleNotifications}) {
    const [formData, setFormData] = useState(defaultFormData);
    const [reminders, setReminders] = useState([]);
    const [creatingReminder, setCreatingReminder] = useState(false);


    const getReminders = async () => {
        try {
            const data = await getAllLeadReminders()
            setReminders(data);
        } catch (error) {
            console.log('Error fetching reminders:', error);
        }
    }

    const handleChange = (evt) => {
        const newFormData = {
            ...formData,
            [evt.target.name]: evt.target.value,
        };
        setFormData(newFormData);
    }

    const handleSubmit = async (evt) => {
        evt.preventDefault();
        setCreatingReminder(true);
        try {
            const updatedReminderList = await createLeadReminder(formData, user._id);
            setReminders(updatedReminderList);
            setFormData(defaultFormData);
            document.getElementById('newLeadReminderForm').reset();
            formNotificationStyle2('createReminderNotification', 'Reminder Created!', '#0A7637', '1');
            toggleNotifications('success', `Reminder Created ${formData.numberOfDays} ${formData.numberOfDays==='1'? 'day':'days'} before ${leadReminderFields.find(field => field.value === formData.fieldOfInterest).name}!`, '#FFFFFF');
        } catch (error) {
            console.log('Error creating reminder:', error);
            toggleNotifications('error', 'Failed to Create Reminder!', '#FFFFFF');
        }
        setCreatingReminder(false);
    }

    useEffect(() => {
        getReminders();
        // eslint-disable-next-line
    }, []);

    
  return (
    <div className='LeadReminders modal fade' id={`leadRemindersModal`}  data-bs-keyboard="true">
        <div className='modal-dialog'>
            <div className="modal-content">
                <div className='header'>
                    <div className='left'>
                        <div className='first'>
                            <svg width="25" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" opacity='0.8'>
                                <path d="M1.6665 14.1666L9.99984 18.3333L18.3332 14.1666M1.6665 9.99996L9.99984 14.1666L18.3332 9.99996M9.99984 1.66663L1.6665 5.83329L9.99984 9.99996L18.3332 5.83329L9.99984 1.66663Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>                    
                            </svg>
                        </div>
                        <div className='second'>
                            <div className='sec1'>
                                Lead Reminders
                            </div>
                        </div>
                    </div>
                    <div className='right'>
                        <svg data-bs-dismiss="modal" width="25" viewBox="0 0 33 33" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="16.2666" cy="16.2666" r="15.7666" fill="#EDEFF2" stroke="#EEEEEE"/>
                            <path d="M21.1093 12L12 21.1093M12 12L21.1093 21.1093" stroke="#1B2B41" strokeOpacity="0.8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </div>
                </div>
                <div className='mainContainer'>
                    <div className='currentReminders'>
                        <div className='container'>
                            <div className='sectionTitle'>Current Reminders <small><i>(Hover over item for more details)</i></small></div>
                            <div className='sectionContent'>
                            {reminders.map((reminder, index) => (
                                <div key={index} className='reminderItem tooltipContainer'>
                                    <div>
                                        ({capitalizeFirstLetter(reminder.status)} Leads)
                                    </div>
                                    <div>
                                        {reminder.numberOfDays} Day{reminder.numberOfDays !== 1 && 's'}
                                    </div>
                                    <div>
                                        {reminder.beforeOrAfter === 'before' ? 'Before' : 'After'}
                                    </div>
                                    <div>
                                        {(leadReminderFields.find(field => field.value === reminder.fieldOfInterest)).name}
                                    </div>
                                    <span className="tooltiptext">{reminder.message}</span>
                                </div>
                            ))}
                            </div>
                        </div>
                    </div>
                    <div className='newReminder'>
                        <div className='sectionTitle'>New Reminder</div>
                        <form id='newLeadReminderForm' onSubmit={handleSubmit}>
                            <div className='formContent'>
                                <div className="">
                                    <label htmlFor="status" className="form-label">Reminder For:</label>
                                    <select className='form-select' name="status" id="status" defaultValue={formData.status} onChange={handleChange} required>
                                        <option value="">---Select Lead Type---</option>
                                        <option value="active">Active Leads</option>
                                        <option value="hot">Hot Leads</option>
                                        <option value="dead">Dead Leads</option>
                                    </select>
                                </div>
                                <div className="">
                                    <label htmlFor="numberOfDays" className="form-label">Number of Days:</label>
                                    <input type="number" min={1} className="form-control" name="numberOfDays" id="numberOfDays" defaultValue={formData.numberOfDays} onChange={handleChange} required />
                                </div>
                                <div className=''>
                                    <label htmlFor="beforeOrAfter" className="form-label">Before / After:</label>
                                    <select className='form-select' name="beforeOrAfter" id="beforeOrAfter" defaultValue={formData.beforeOrAfter} onChange={handleChange} required>
                                        <option value="">---Select Option---</option>
                                        <option value="before">Before</option>
                                        <option value="after">After</option>
                                    </select>
                                </div>
                                <div className="">
                                    <label htmlFor="fieldOfInterest" className="form-label">Applicable Date:</label>
                                    <select className='form-select' name="fieldOfInterest" id="fieldOfInterest" defaultValue={formData.fieldOfInterest} onChange={handleChange} required>
                                        <option value="">---Select Date of Interest---</option>
                                        {leadReminderFields.map((field, index) => (
                                            <option key={index} value={field.value}>{field.name}</option>
                                        ))}
                                    </select>
                                </div>
                                <div className="">
                                    <label htmlFor="message" className="form-label">Message:</label>
                                    <textarea className="form-control" rows={2} name="message" id="message" defaultValue={formData.message} onChange={handleChange} required />
                                </div>
                            </div>
                            <div id='createReminderNotification' className='text-center'></div>
                            <div className='buttonContainer'>
                                <button type="submit" form='newLeadReminderForm' className="submit" disabled={creatingReminder}>Create Reminder</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}
